import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { reducer as formReducer } from "redux-form";
import Init from "./init";
import Auth from "./auth";

import Project from "./project";
import Team from "./team";

import User from "./user";
import Province from "./province";
import PettyCashierAccountReview from "./accountReview/pettyCashierAccountReview";
import ManagerAccountReview from "./accountReview/managerAccountReview";
import PettyCashierPayment from "./payment/pettyCashierPayment";
import ManagerPayment from "./payment/managerPayment";
import PettyCashierReceive from "./receive/pettyCashierReceive";
import ManagerReceive from "./receive/managerReceive";
import Event from "./event";
import Dashboard from "./dashboard/pettyCashierDashboard";
import ManagerDashboard from "./dashboard/managerDashboard";
import { reducer as toastrReducer } from "react-redux-toastr";
import PettyCashierOverallCost from "./overallCost/pettyCashierOverallCost";
import ManagerOverallCost from "./overallCost/managerOverallCost";
import PettyCashierOverallCostDetail from "./overallCost/detail/pettyCashierOverallCostDetail";
import ManagerOverallCostDetail from "./overallCost/detail/managerOverallCostDetail";
import Notification from "./notification";
import NotificationResponse from "./notificationResponse";
import PettyCashierPettyCash from "./pettyCash/pettyCashierPettyCash";
import ManagerPettyCash from "./pettyCash/managerPettyCash";
import PettyCash from "./pettyCash";
import ProjectSetting from "./projectSetting";
import File from "./file";
import DownloadFile from "./downloadFile";
import UploadImage from "./uploadImage";
import Ticket from "./ticket";
import Announcement from "./announcement";
import Invitation from "./invitation";
import Premium from "./premium";
import Transaction from "./transaction";
import CountryCode from "./countryCode";
import Currencies from "./currencies";

import AccountTitle from "./accountTitle";
import CostCenter from "./costCenter";
import Hashtag from "./hashtag";
import Contact from "./contact";

import PettyCashierMonthlyReview from "./monthlyReview/pettyCashierMonthlyReview";
import PettyCashierMonthlyBudget from "./monthlyBudget/pettyCashierMonthlyBudget";
import PettyCashierMonthlyBudgetReview from "./monthlyBudget/review/pettyCashierMonthlyBudgetReview";
import PettyCashierHashtagReport from "./hashtagReport/pettyCashierHashtagReport";
import ManagerHashtagReport from "./hashtagReport/managerHashtagReport";
import PettyCashierHashtagDetailReport from "./hashtagReport/detail/pettyCashierHashtagDetailReport";
import ManagerHashtagDetailReport from "./hashtagReport/detail/managerHashtagDetailReport";
import GeneralUtils from "./generalUtils";

import PremiumFeature from "./generalModalsOrWarnings/feature";
import PremiumGuest from "./generalModalsOrWarnings/guest";
import ChangeAccessDenied from "./generalModalsOrWarnings/changeAccessDenied";

import PanelSelection from "./panelSelectionModal";
import SubItemsShared from "./subItems";
import PettyCashierPettyCashBudget from "./pettyCashBudget/pettyCashierPettyCashBudget";
import ManagerPettyCashBudget from "./pettyCashBudget/managerPettyCashBudget";
import PettyCashierContactReport from "./contactReport/pettyCashierContactReport";
import ManagerContactReport from "./contactReport/managerContactReport";
import PettyCashierContactDetailReport from "./contactReport/detail/pettyCashierContactDetailReport";
import ManagerContactDetailReport from "./contactReport/detail/managerContactDetailReport";

import PettyCashierVatReview from "./vatReview/pettyCashierOverallCostDetail";
import ManagerVatReview from "./vatReview/managerOverallCostDetail";

import UserManagement from "./userManagement";
import PettyCashierSelection from "./pettyCashierSelectionModal";

import PettyCashierCurrentPettyCashBudgetComparativeReport from "./pettyCashBudget/pettyCashierBudgetComparativeReport";

export default history =>
  combineReducers({
    router: connectRouter(history),
    Init: Init,
    Auth: Auth,
    Project: Project,
    Team: Team,
    User: User,
    Province: Province,
    PettyCashierAccountReview: PettyCashierAccountReview,
    ManagerAccountReview: ManagerAccountReview,
    PettyCashierPayment: PettyCashierPayment,
    ManagerPayment: ManagerPayment,
    PettyCashierReceive: PettyCashierReceive,
    ManagerReceive: ManagerReceive,
    Event: Event,
    Dashboard: Dashboard,
    ManagerDashboard: ManagerDashboard,
    form: formReducer,
    toastr: toastrReducer,
    PettyCashierOverallCost: PettyCashierOverallCost,
    ManagerOverallCost: ManagerOverallCost,
    PettyCashierOverallCostDetail: PettyCashierOverallCostDetail,
    PettyCashierVatReview: PettyCashierVatReview,
    ManagerVatReview: ManagerVatReview,
    ManagerOverallCostDetail: ManagerOverallCostDetail,
    Notification: Notification,
    NotificationResponse: NotificationResponse,
    PettyCashierPettyCash: PettyCashierPettyCash,
    ManagerPettyCash: ManagerPettyCash,
    PettyCash: PettyCash,
    ProjectSetting: ProjectSetting,
    File: File,
    DownloadFile,
    UploadImage,
    Ticket: Ticket,
    Announcement: Announcement,
    Invitation: Invitation,
    Premium: Premium,
    Transaction: Transaction,
    CountryCode: CountryCode,
    Currencies: Currencies,
    AccountTitle: AccountTitle,
    CostCenter: CostCenter,
    Hashtag: Hashtag,
    Contact: Contact,
    PettyCashierMonthlyReview: PettyCashierMonthlyReview,
    PettyCashierMonthlyBudget: PettyCashierMonthlyBudget,
    PettyCashierMonthlyBudgetReview: PettyCashierMonthlyBudgetReview,
    PettyCashierContactReport: PettyCashierContactReport,
    ManagerContactReport: ManagerContactReport,
    PettyCashierContactDetailReport: PettyCashierContactDetailReport,
    ManagerContactDetailReport: ManagerContactDetailReport,
    PettyCashierHashtagReport: PettyCashierHashtagReport,
    ManagerHashtagReport: ManagerHashtagReport,
    PettyCashierHashtagDetailReport: PettyCashierHashtagDetailReport,
    ManagerHashtagDetailReport: ManagerHashtagDetailReport,
    GeneralUtils: GeneralUtils,

    PremiumFeature: PremiumFeature,
    PremiumGuest: PremiumGuest,
    ChangeAccessDenied: ChangeAccessDenied,

    PanelSelection: PanelSelection,
    PettyCashierSelection: PettyCashierSelection,
    SubItemsShared: SubItemsShared,

    PettyCashierPettyCashBudget: PettyCashierPettyCashBudget,
    ManagerPettyCashBudget: ManagerPettyCashBudget,
    PettyCashierCurrentPettyCashBudgetComparativeReport: PettyCashierCurrentPettyCashBudgetComparativeReport,

    UserManagement: UserManagement
  });
